var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("ellipse",{"cx":"80.5","cy":"78","fill":"#262f38","rx":"80.5","ry":"78","key":0}),React.createElement("path",{"d":"m96.5235354 46.9254996 39.5050036 61.4522274c.895956 1.39371.492447 3.249852-.901263 4.145808-.483892.311074-1.047018.476465-1.622272.476465h-79.0100075c-1.6568543 0-3-1.343146-3-3 0-.575255.1653911-1.138381.4764646-1.622273l39.5050035-61.4522274c.8959565-1.3937102 2.752098-1.7972192 4.1458082-.9012627.3615079.232398.6688647.5397547.9012626.9012627z","fill":"#d2d2d2","transform":"matrix(0 1 -1 0 172 -16)","key":1})]));
}

PlayButton.defaultProps = {"height":"156","viewBox":"0 0 161 156","width":"161"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
